<div *ngIf="isVisible"
     class="fixed-bottom-arrow-up"
     (click)="moveTop()">
  <i class="fa fa-angle-up bounce"></i>
  <a class="move-top"></a>
</div>
